module.exports = __webpack_public_path__ + "img/27e0c0d.svg";